import React, { useMemo, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import MostLoginTimeChart from "./MostLoginTimeChart";
import AllTimePeakLoginChart from "./AllTimePeakLoginChart";

export default function LoginTimeCharts() {
  const currentYear = new Date().getFullYear();

  const yearOptions = useMemo(() => {
    const startYear = 2025; 
    const years = [];
    for (let y = currentYear; y >= startYear; y--) {
      years.push(y);
    }
    return years;
  }, [currentYear]);

  const [selectedYear, setSelectedYear] = useState(currentYear);

  return (
    <div>
      <Row className="g-4">
        <Col xs={12}>
          <div className="mb-1 small fw-semibold">Most active hours today</div>
          <div
            style={{
              width: "40px",
              height: "3px",
              backgroundColor: "#3B82F6",
              borderRadius: "2px",
              marginBottom: "10px",
            }}
          ></div>
          <MostLoginTimeChart type="daily" />
        </Col>
      </Row>

      <Row className="g-4 mt-3">
        <Col xs={12} md={6}>
          <div className="mb-1 small fw-semibold">
            Most active days this week
          </div>
          <div
            style={{
              width: "40px",
              height: "3px",
              backgroundColor: "#A855F7",
              borderRadius: "2px",
              marginBottom: "10px",
            }}
          ></div>
          <MostLoginTimeChart type="weekly" />
        </Col>
        <Col xs={12} md={6}>
          <div className="mb-1 small fw-semibold">
            Most active months this year
          </div>
          <div
            style={{
              width: "40px",
              height: "3px",
              backgroundColor: "#22C55E",
              borderRadius: "2px",
              marginBottom: "10px",
            }}
          ></div>
          <MostLoginTimeChart type="monthly" />
        </Col>
      </Row>

      <Row className="g-4 mt-4">
        <Col xs={12}>
          <div className="d-flex justify-content-between align-items-center mb-1">
            <div className="small fw-semibold">All-time Peak Login Hour</div>
            <Form.Select
              size="sm"
              style={{ maxWidth: 140 }}
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              {yearOptions.map((y) => (
                <option key={y} value={y}>
                  Year {y}
                </option>
              ))}
            </Form.Select>
          </div>

          <div
            style={{
              width: "40px",
              height: "3px",
              backgroundColor: "#0EA5E9",
              borderRadius: "2px",
              marginBottom: "10px",
            }}
          ></div>

          <AllTimePeakLoginChart year={selectedYear} />
        </Col>
      </Row>
    </div>
  );
}